import React from 'react';
import { useStoreState } from 'easy-peasy';
import CancelAndRefundForm from './CancelAndRefundForm';

const CancelAndRefundModal = ({
  isActiveCancelModal,
  setActiveCancelModal,
  handleCancelOrder,
  order,
}) => {
  const { userId } = useStoreState(state => state.auth);
  return (
    <CancelAndRefundForm
      isActive={isActiveCancelModal}
      handleCancelOrder={handleCancelOrder}
      order={order}
      userId={userId}
      onClose={() => setActiveCancelModal(false)}
    />
  );
};
export default CancelAndRefundModal;
